// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ArrowUpSolid = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ArrowUpSolid = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ArrowUpSolid = _exports.ArrowUpSolid = function ArrowUpSolid(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10.8857 1.61621C10.3975 1.12793 9.60449 1.12793 9.11621 1.61621L2.86621 7.86621C2.37793 8.35449 2.37793 9.14746 2.86621 9.63574C3.35449 10.124 4.14746 10.124 4.63574 9.63574L8.75293 5.51465V17.499C8.75293 18.1904 9.31152 18.749 10.0029 18.749C10.6943 18.749 11.2529 18.1904 11.2529 17.499V5.51855L15.3701 9.63184C15.8584 10.1201 16.6514 10.1201 17.1396 9.63184C17.6279 9.14356 17.6279 8.35059 17.1396 7.8623L10.8896 1.6123L10.8857 1.61621Z",
      fill: "currentColor"
    }));
  };
});
